"use client";

import Link from "next/link";
import {InputLogin} from "@/components/tailwindComponents/input-fields/input-login";
import {FieldValues, SubmitHandler, useForm} from 'react-hook-form';
import useAuth from "@/hooks/UseAuth";
import React, {useEffect, useState} from "react";
import Spinner from "@/components/tailwindComponents/Spinner";
import {EyeIcon, EyeSlashIcon} from "@heroicons/react/24/solid";
// import converMobileNumber from "@/components/utils/ConverMobileNumber";
import {useSearchParams} from "next/navigation";
import ForgetPassword from "@/components/auth/password/ForgetPassword";
import AuthWrapper from "@/components/wrappers/AuthWrapper";

export default function LoginPage() {
    const {register, handleSubmit, formState: {errors}} = useForm<FieldValues>();
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const {loginUser} = useAuth();
    const [showForgetPassword, setShowForgetPassword] = useState<boolean>(false);
    const [titleText, setTitleText] = useState<string>("ورود");
    // const [error, setError] = useState<AxiosError | null>(null);

    const searchParams = useSearchParams();
    const redirect = decodeURIComponent(searchParams.get("redirect") || "");

    const onSubmit: SubmitHandler<FieldValues> = async (data) => {
        const {username, password} = data;
        setButtonLoading(true);
        await loginUser(username, password, redirect);
        setButtonLoading(false);
        // const response = await AUTH.token(username, password);
    };

    useEffect(() => {
        if (showForgetPassword) {
            setTitleText("تغییر رمز")
        } else {
            setTitleText("ورود")
        }
    }, [showForgetPassword]);

    // Eye icons for password
    const renderIcon = (isVisible: boolean, toggle: () => void) => (
        <button
            type="button"
            onClick={toggle}
            className="absolute top-0 bottom-0 right-3 flex items-center text-gray-500"
        >
            {isVisible ? <EyeIcon className="h-5 w-5"/> : <EyeSlashIcon className="h-5 w-5"/>}
        </button>
    );

    return (
        <AuthWrapper label={titleText}>
            {/*{error && (<ErrorHandler error={error}/>)}*/}
            <div className="mt-4 w-full">
                {showForgetPassword ? (
                    <ForgetPassword
                        // setForgetPasswordError={(prop) => setError(prop)}
                        setShowForgetPassword={(prop) => setShowForgetPassword(prop)}/>
                ) : (
                    <div>
                        <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
                            <InputLogin
                                name="username"
                                label="شماره موبایل"
                                type="text"
                                dir="ltr"
                                // prefix="+98"
                                register={register('username', {required: 'نام کاربری الزامی است'}
                                    // , {
                                    // required: 'شماره موبایل الزامی است',
                                    // validate: (value) =>
                                    //     /^0?\d{10}$/.test(value) || 'شماره موبایل معتبر وارد کنید.',
                                    // }
                                )}
                                error={errors.username?.message as string}
                            />
                            <InputLogin
                                name="password"
                                label="رمز عبور"
                                type="password"
                                dir="ltr"
                                register={register('password', {required: 'رمز عبور الزامی است'})}
                                error={errors.password?.message as string}
                                icon={renderIcon}
                            />
                            <div className="flex justify-end text-sm mt-12">
                                <p className="text-primary hover:text-indigo-500 hover:cursor-pointer"
                                   onClick={() => setShowForgetPassword(true)}>فراموشی رمز
                                    عبور
                                </p>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    disabled={buttonLoading}
                                    className="
            group
            relative
            flex
            h-12
            w-full
            items-center
            justify-center
            overflow-hidden

            rounded-xl

            border
            border-primary/60

            bg-primary

            px-3

            text-sm/6
            font-bold
            text-white

            shadow-[
                inset_0_1px_2px_rgba(255,255,255,0.45),
                inset_0_-2px_3px_rgba(0,0,0,0.18),
                0_5px_15px_rgba(0,0,0,0.15)
            ]

            transition-all
            duration-300
            ease-out

            hover:bg-primary
            hover:border-primary/80

            hover:shadow-[
                inset_0_1px_2px_rgba(255,255,255,0.7),
                inset_0_-2px_4px_rgba(0,0,0,0.22),
                0_8px_22px_rgba(0,0,0,0.2)
            ]

            hover:cursor-pointer

            active:scale-[0.98]

            disabled:pointer-events-none
            disabled:opacity-60
        "
                                >
                                    {/* Liquid reflection */}
                                    <span
                                        className="
                pointer-events-none
                absolute
                inset-0
                flex
                h-full
                w-full
                justify-center

                [transform:skew(-18deg)_translateX(-150%)]

                transition-transform
                duration-700
                ease-out

                group-hover:[transform:skew(-18deg)_translateX(150%)]
            "
                                    >
            <span
                className="
                    h-full
                    w-14
                    bg-gradient-to-r
                    from-transparent
                    via-white/25
                    to-transparent
                    blur-[3px]
                "
            />
        </span>

                                    {/* Top highlight */}
                                    <span
                                        className="
                pointer-events-none
                absolute
                inset-x-4
                top-0
                h-px
                bg-gradient-to-r
                from-transparent
                via-white/70
                to-transparent
            "
                                    />

                                    <span className="relative z-10">
            {buttonLoading ? (
                <Spinner className="h-6 w-6"/>
            ) : (
                "ورود"
            )}
        </span>
                                </button>
                            </div>
                        </form>
                        <div className="relative mt-24 hidden md:block">
                            <div aria-hidden="true" className="absolute inset-0 flex items-center">
                                <div className="w-full border-t border-indigo-950"/>
                            </div>
                            <div className="relative flex justify-center text-sm font-medium leading-6">
                                <span
                                    className="bg-blue-100 px-4 text-gray-900 rounded-lg border border-indigo-950 font-bold p-1">حساب کاربری ندارید؟</span>
                            </div>
                        </div>
                        <div className="mt-4 flex items-center justify-end pb-6 sm:mt-12">
                            <Link href="/signup" className="w-full">
                                <button
                                    type="button"
                                    className="
                relative
                flex
                h-11
                w-full
                items-center
                justify-center
                overflow-hidden

                rounded-xl

                border
                border-indigo-300/60

                bg-white/25

                px-3

                text-sm/6
                font-bold
                text-indigo-700
                cursor-pointer
                backdrop-blur-xl

                transition-all
                duration-200

                hover:bg-white/45
                hover:border-indigo-400/70
                hover:text-indigo-800

                active:scale-[0.99]
            "
                                >
            <span
                className="
                    pointer-events-none
                    absolute
                    inset-x-5
                    top-0
                    h-px
                    bg-gradient-to-r
                    from-transparent
                    via-white/80
                    to-transparent
                "
            />

                                    <span className="relative z-10">
                ثبت نام
            </span>
                                </button>
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        </AuthWrapper>
    );
}
